import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { DeclinationMnemonic } from '@common/model/resource/declinationMnemonic';
import { useDeclination } from '@cp/shared/declination';

export const useAuthorAgeLabel = (data: CatalogItemViewModel | undefined): string => {
  const declination = useDeclination();

  const age = data?.clientProfile?.age;

  if (!age) {
    return '';
  }

  return `${age} ${declination(Number(age), DeclinationMnemonic.Year)}`;
};
